<style scoped>
    .vue-modal {
        display: block;
    }
</style>
<template>
    <div style="display: inline-block">
        <button
                class="btn btn-primary btn-sm"
                @click="getStickers()"
                :title="trans('show_stickers')"><i class="fa fa-image"></i>
        </button>
        <button
                class="btn btn-primary btn-sm"
                @click="printRegisterShipmentFile()"
                :title="trans('show_registered_shipment_file')"><i class="fa fa-truck"></i>
        </button>
    </div>
</template>

<script>
    import * as Functions from '../../Functions';

    export default {
        props: ['translations'],
        data: function () {
            return {
                checked: [],
                delivery_type_code: 'ups'
            };
        },
        methods: {
            trans(name, path = 'print_controls') {
                return Functions.trans(this.translations, name, path);
            },
            getStickers: function () {
                if (this.checkLength()) {
                    return this.$parent.$options.methods.openWithPost('/shop/orders/print/stickers', {
                        ids: this.checked,
                        delivery_type_code: this.delivery_type_code
                    });
                }
            },
            printRegisterShipmentFile: function () {
                if (this.checkLength()) {
                    return this.$parent.$options.methods.openWithPost('/shop/orders/print/register_shipment_file', {
                        ids: this.checked,
                        delivery_type_code: this.delivery_type_code,
                    });
                }
            },
            checkLength: function () {
                if (this.checked.length < 1) {
                    alert(this.trans('orders_not_selected', null));
                    return false;
                }
                return true;
            },
            printParams: function () {
                return {
                    ids: this.checked,
                    delivery_type_code: this.delivery_type_code,
                    chosen_requisite: this.chosen_requisite
                }
            },
        },
        created: function () {
            this.$root.$on('update:checked', (val) => {
                this.checked = val;
            });
        }
    }
</script>
